import { PromoState } from "../../common/requests/promotions/endpoints";
import { StatusPill, Tone } from "../../ui";
import { STATE_LABEL } from "./promoText";

// Owner's colours: Live green, Scheduled ink, Draft grey, Paused coral text
// colour, Ended outlined green.
const TONE: Record<PromoState, Tone> = {
  live: "success",
  scheduled: "ink",
  draft: "neutral",
  paused: "warning",
  ended: "finished",
};

export default function StateBadge({ state, legacy }: { state: PromoState; legacy?: boolean }) {
  return (
    <StatusPill tone={TONE[state]} title={legacy ? "An old Stripe code from before vouchers" : undefined}>
      {STATE_LABEL[state]}
    </StatusPill>
  );
}
